<div class="table-container">
  <p-table #dt [value]="rows" scrollWidth="100%" [paginator]="type == TableType.PAGINATOR" [styleClass]="''"
    [rows]="type == TableType.PAGINATOR ? rowByPageDefault : 70"
    [rowsPerPageOptions]="type === TableType.PAGINATOR ? [15, 30, 60] : undefined"
    [virtualScroll]="type != TableType.PAGINATOR" [scrollable]="true"
    [scrollHeight]="type != TableType.PAGINATOR ? scrollHeight : undefined"
    [virtualRowHeight]="type != TableType.PAGINATOR ? virtualRowHeight : undefined"
    [globalFilterFields]="globalFilterFields" class="p-datatable-sm custom-table" [first]="0">
    <!-- Funcionalidades -->
    <ng-template pTemplate="caption">
      <div class="d-flex space-between w-100">
        <div class="d-flex flex-column gap-2 mb-2">
          <!-- Barra superior con búsqueda -->
          <div class="p-d-flex p-jc-between p-ai-center p-flex-wrap">
            <div class="p-input-icon-left" style="width: 250px;">
              <i class="pi pi-search"></i>
              <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                placeholder="Buscar..." class="p-inputtext-sm w-full" />
            </div>
          </div>
        </div>

        <!-- controladores -->
        <div class="d-flex justify-content-center align-items-center gap-3" style="margin-left:auto; font-size:0.9rem;">
          <!-- Resumen de registros -->
          <div class="text-secondary d-flex align-items-center gap-2">
            <span>Total: <strong>{{ (totalRecords !== null && totalRecords !== undefined && totalRecords !== '' &&
                totalRecords !== 0)
                ? totalRecords
                : dt.totalRecords }}</strong> registros</span>

            <span *ngIf="type === TableType.PAGINATOR && dt.totalRecords > 0">
              - Mostrando de <strong>{{ dt.first + 1 }}</strong> a
              <strong>{{ dt.first + dt.rows > dt.totalRecords ? dt.totalRecords : dt.first + dt.rows }}</strong>
            </span>
          </div>


          <ng-content select="[controls]"></ng-content>
          <ng-container *ngIf="withButtonDriversList">
            <button class="btn btn-primary btn-sm" (click)="updateDriversList()">
              <i class="bi bi-eye"></i> Actualizar lista
            </button>
          </ng-container>

          <!-- Botón "Ver Todo" -->
          <div *ngIf="withButtonGeneral">
            <button class="btn btn-primary btn-sm" (click)="verTodosGeneral()">
              <i class="bi bi-eye"></i> Ver Todo
            </button>
          </div>
        </div>

      </div>
    </ng-template>


    <!-- Cabezera -->
    <ng-template pTemplate="header">
      <tr>
        <th *ngFor="let col of columns" [style.width]="col.width" [pSortableColumn]="sortColumns ? col.field : null"
          [hidden]="col.hidden" class="header-cell">

          <ng-container *ngIf="col">
            <ng-container [ngSwitch]="col.field">
              <ng-container *ngSwitchCase="'excesoVelocidad'">
                <ng-container *ngIf="col.subColumns?.length; else defaultHeader">
                  <div style="display: flex; flex-direction: column; align-items: start;">
                    <div style="width: 100%; text-align: center"><strong>{{ col.header }}</strong></div>
                    <div
                      style="display: flex; gap: 16px; margin-top: 4px; justify-content: space-between; width: 100%; align-items: center;">
                      <ng-container *ngFor="let sub of col.subColumns">
                        <span [ngClass]="{
                          'text-green': sub.field === 'leve',
                          'text-yellow': sub.field === 'grave',
                          'text-red': sub.field === 'muyGrave'
                        }" style="font-weight: normal; width: 100%; text-align: center;">{{ sub.header }}</span>
                      </ng-container>
                    </div>
                  </div>
                </ng-container>
                <ng-template #defaultHeader>
                  <span>
                    {{ col.header }}
                  </span>
                  <p-sortIcon *ngIf="sortColumns" [field]="col.field"></p-sortIcon>
                </ng-template>
              </ng-container>

              <ng-container *ngSwitchCase="'datosEvento'">
                <div style="display: flex; flex-direction: column; align-items: start;">
                  <div style="width: 100%; text-align: center"><strong>{{ col.header }}</strong></div>
                  <div
                    style="display: flex; gap: 16px; margin-top: 4px; justify-content: space-between; width: 100%; align-items: center;">
                    <ng-container *ngFor="let sub of col.subColumns">
                      <span style="font-weight: normal; width: 100%; text-align: center;">{{ sub.header }}</span>
                    </ng-container>
                  </div>
                </div>
              </ng-container>

              <ng-container *ngSwitchCase="'datosChecklist'">
                <div style="display: flex; flex-direction: column; align-items: start;">
                  <div style="width: 100%; text-align: center"><strong>{{ col.header }}</strong></div>
                  <div
                    style="display: flex; gap: 16px; margin-top: 4px; justify-content: space-between; width: 100%; align-items: center;">
                    <ng-container *ngFor="let sub of col.subColumns">
                      <span style="font-weight: normal; width: 100%; text-align: center;">{{ sub.header }}</span>
                    </ng-container>
                  </div>
                </div>
              </ng-container>

              <ng-container *ngSwitchDefault>
                <span>
                  {{ col.header }}
                </span>
                <p-sortIcon *ngIf="sortColumns" [field]="col.field"></p-sortIcon>
              </ng-container>
            </ng-container>
          </ng-container>
        </th>
      </tr>
    </ng-template>

    <!-- Registros de la tabla -->
    <ng-template pTemplate="body" let-row let-rowIndex="rowIndex">
      <tr [ngClass]="{
          'fila-par': applyStripedColor && (dt.first + rowIndex) % 2 === 0,
          'fila-impar': applyStripedColor && (dt.first + rowIndex) % 2 !== 0
        }" [style.background-color]="row.isResumen == true ? '#E5E3D9 !important' : ''">
        <td *ngFor="let col of columns" [style.width]="col.width" class="body-cell" [hidden]="col.hidden">

          <ng-container *ngIf="col">
            <ng-container [ngSwitch]="col.field">
              <ng-container *ngSwitchCase="'ubicacion'">
                <a [href]="row.ubicacionLink" target="_blank">{{row.ubicacion}}</a>
              </ng-container>

              <ng-container *ngSwitchCase="'observacion'">
                <input pInputText type="text" [(ngModel)]="row.observacion" (change)="onChangeObservacion(row)">
              </ng-container>


              <ng-container *ngSwitchCase="'excesoVelocidad'">
                <div
                  style="display: flex; gap: 16px; margin-top: 4px; justify-content: space-between; width: 100%; align-items: center;">
                  <ng-container *ngIf="col.subColumns?.length; else showExceso">
                    <ng-container *ngFor="let sub of col.subColumns">
                      <span style="font-weight: normal; width: 100%; text-align: center;" [ngClass]="{
                          'text-green': sub.field === 'leve',
                          'text-yellow': sub.field === 'grave',
                          'text-red': sub.field === 'muyGrave'
                        }">
                        {{ row[sub.field] || "-" }}
                      </span>
                    </ng-container>
                  </ng-container>

                  <ng-template #showExceso>
                    <span style="font-weight: normal; width: 100%; text-align: center;">
                      {{ row.excesoVelocidad || "-" }}
                    </span>
                  </ng-template>
                </div>

              </ng-container>


              <ng-container *ngSwitchCase="'newDriver'">
                <div class="d-flex flex-column gap-1 w-100">

                  <!-- Posible conductor -->
                  <p-dropdown
                    [showClear]="true"
                    [panelStyle]="{
                      'font-size': '10px',
                      'border-radius': '4px',
                      'border': '1px solid #00000011'
                    }"
                    [style]="{
                      width: '100%',
                      'font-size': '10px',
                      'border': '1px solid #00000011',
                      'border-radius': '4px'
                    }"
                    [appendTo]="'body'"
                    [options]="driverKeyCipia"
                    [(ngModel)]="row.newDriverId"
                    [filter]="true"
                    placeholder="Selecciona un posible conductor"
                    optionLabel="nombre_conductor"
                    optionValue="id"
                    (onChange)="onDriverIdentificationChange($event, row)"
                    emptyMessage="No se encontraron registros"
                    emptyFilterMessage="No se han encontrado criterios">
                  </p-dropdown>

                  <!-- Conductor no identificado -->
                  <div
                    class="d-flex align-items-center gap-1 mt-1"
                    style="font-size: 10px; cursor: pointer;"
                  >
                    <p-checkbox
                      [(ngModel)]="row.isUnknownDriver"
                      [binary]="true"
                      inputId="driverUnknown"
                      (onChange)="onDriverUnknownChange($event, row)">
                    </p-checkbox>
                    <label for="driverUnknown">Conductor no identificado</label>
                  </div>

                </div>
              </ng-container>

              <ng-container *ngSwitchCase="'criterioEvaluacion'">
                <p-dropdown [showClear]="true"
                  [panelStyle]="{ 'background-color': '#ffffff', 'font-size': '0.875rem', 'box-shadow': 'none', 'border-radius': '0' }"
                  [appendTo]="'body'" [options]="getCriterioEvaluationOptionsForRow(row.slug)" [group]="true"
                  [(ngModel)]="row.criterioId" filterBy="label" placeholder="Criterios ..."
                  (onChange)="onChangeCriterioEvaluacion($event, row)" emptyMessage="No se encontraron registros"
                  emptyFilterMessage="No se han encontrado Criterios" filterMatchMode="contains"
                  [style]="{ width: '100%', 'max-width': '15rem', padding: '0.5rem 0.5rem', 'font-family': 'Arial, sans-serif' }">

                  <!-- Estilizando el grupo -->
                  <ng-template let-group pTemplate="group">
                    <div class="p-d-flex p-ai-center d-flex justify-content-center">
                      <span>{{ group.label }}</span>
                    </div>
                  </ng-template>

                  <!-- Estilizando el ícono de dropdown -->
                  <ng-template let-option pTemplate="selectedItem">
                    <div class="p-d-flex p-ai-center">
                      <span>{{ option.label || option.value }}</span>
                    </div>
                  </ng-template>

                </p-dropdown>


                <span *ngIf="row.criterioId || row.fechaEvaluacion">
                  {{row.criterioEvaluacion || 'Sin criterio'}}
                </span>

                <br *ngIf="row.senalesPosibleFatiga">
                <input *ngIf="row.senalesPosibleFatiga" pInputText type="text" [(ngModel)]="row.identificacionVideo"
                  (change)="onChangeObservacion(row)" placeholder="Identificar video">

                <div *ngIf="row.isConfirmed" class="form_stars">
                  <p class="clasificacion">
                    <ng-container *ngFor="let star of [5,4,3,2,1]; let i = index">
                      <input id="radio{{star}}_{{rowIndex}}" type="radio" [(ngModel)]="row.valoracionEvento"
                        (change)="onChangeObservacion(row)" [value]="star" />
                      <label for="radio{{star}}_{{rowIndex}}">★</label>
                    </ng-container>
                  </p>
                </div>
              </ng-container>

              <ng-container *ngSwitchCase="'enlaceArchivo'">
                <ng-container *ngIf="row.enlaceImagen && row.enlaceImagen !== '-'; else noImg">
                  <a [href]="row.enlaceImagen" target="_blank">Imagen</a>
                </ng-container>
                <ng-template #noImg>-</ng-template>
                /
                <ng-container *ngIf="row.enlaceVideo && row.enlaceVideo !== '-'; else noVid">
                  <a [href]="row.enlaceVideo" target="_blank">Video</a>
                </ng-container>
                <ng-template #noVid>-</ng-template>
              </ng-container>

              <ng-container *ngSwitchCase="'zonaColor'">
                <div style="display: flex; align-items: center; gap: 8px;">
                  <!-- Muestra de color -->
                  <div [style.backgroundColor]="row[col.field]"
                    style="width: 16px; height: 16px; border-radius: 4px; border: 1px solid #ccc;"></div>
                  <!-- Texto del color -->
                  <span>{{ row[col.field] }}</span>
                </div>
              </ng-container>

              <ng-container *ngSwitchCase="'enlaceVideo'">
                <a [href]="row.linkVideo" target="_blank">Video</a>
              </ng-container>

              <ng-container *ngSwitchCase="'enlaceImagen'">
                <a [href]="row.linkImage" target="_blank">Imagen</a>
              </ng-container>

              <ng-container *ngSwitchCase="'conductor'">
                <span>
                  {{ row.conductor }}
                </span>
              </ng-container>

              <ng-container *ngSwitchCase="'datosEvento'">
                <div
                  style="display: flex; gap: 16px; margin-top: 4px; justify-content: space-between; width: 100%; align-items: center;">
                  <ng-container *ngFor="let sub of col.subColumns">
                    <span style="font-weight: normal; width: 100%; text-align: center;" [ngClass]="{
                          'text-green': sub.field === 'leve',
                          'text-yellow': sub.field === 'grave',
                          'text-red': sub.field === 'muyGrave'
                        }">{{ row[sub.field] || "-" }}</span>
                  </ng-container>
                </div>
              </ng-container>

              <ng-container *ngSwitchCase="'previsualizacion'">
                <ng-container *ngIf="imageCache[row.fecha] as img; else pending">
                  <!-- Estado: cargando -->
                  <div *ngIf="img.isLoading" class="image-placeholder">
                    <span class="spinner-border spinner-border-sm mb-2"></span>
                    <span>Cargando imagen...</span>
                  </div>

                  <!-- Estado: éxito -->
                  <img *ngIf="!img.isLoading && !img.hasError" [src]="img.safeUrl" alt="Imagen evento" width="120"
                    height="90" class="rounded shadow" />

                  <!-- Estado: error -->
                  <div *ngIf="img.hasError">
                    <i class="bi bi-exclamation-triangle mb-2"></i>
                    No se pudo cargar la imagen
                  </div>

                </ng-container>

                <!-- Estado inicial: aún no procesado -->
                <ng-template #pending>
                  <div class="image-placeholder">
                    <span class="text-muted">Imagen en proceso</span>
                  </div>
                </ng-template>
              </ng-container>

              <ng-container *ngSwitchCase="'datosChecklist'">
                <div style="display: flex; flex-direction: column; gap: 4px; width: 100%; margin-top: 4px;">
                  <ng-container *ngFor="let checklist of row[col.field]">
                    <div class="checklist-row">
                      <li [ngClass]="{'highlight-driver': row.conductor === checklist.name_driver}">
                        {{ checklist.date_checklist || "-"}}
                      </li>
                      <li [ngClass]="{'highlight-driver': row.conductor === checklist.name_driver}">
                        {{ checklist.name_driver || "-"}}
                      </li>
                      <li [ngClass]="{'highlight-driver': row.conductor === checklist.name_driver}">
                        {{ checklist.string_timing || "-" }}
                      </li>
                      <li [ngClass]="{'highlight-driver': row.conductor === checklist.name_driver}">
                        {{ checklist.cod_driver || "-"}}
                      </li>
                    </div>
                  </ng-container>
                </div>
              </ng-container>

              <ng-container *ngSwitchCase="'operadorMonitoreo'">
                <!-- SELECT estilizado similar a PrimeNG -->
                <select [(ngModel)]="row.operadorMonitoreo" (change)="onChangeOperadorMonitoreo(row)" style="
                          width: 100%;
                          padding: 0.5rem;
                          border: 1px solid #ced4da;
                          border-radius: 0.25rem;
                          background-color: #ffffff;
                          font-size: 0.875rem;
                          font-family: Arial, sans-serif;
                          color: #495057;
                          box-shadow: none;
                          appearance: none;
                          -webkit-appearance: none;
                          -moz-appearance: none;
                        ">
                  <option value="">OPCIONES</option>
                  <option *ngFor="let operator of report.operators" [value]="operator.value">
                    {{ operator.label }}
                  </option>
                  <option value="OTRO">OTRO</option>
                </select>

                <!-- INPUT para opción "OTRO" -->
                <input *ngIf="row.operadorMonitoreo == 'OTRO'" pInputText type="text"
                  [(ngModel)]="row.otroOperadorMonitoreo" (change)="onChangeOperadorMonitoreo(row)"
                  placeholder="Especifique otro operador" style="
                        width: 100%;
                        max-width: 15rem;
                        padding: 0.5rem;
                        font-family: Arial, sans-serif;
                        margin-top: 0.25rem;
                        border: 1px solid #ced4da;
                        border-radius: 0.25rem;
                        font-size: 0.875rem;
                        box-shadow: none;
                      " />

                <!-- Mostrar operador antiguo -->
                <span *ngIf="row.esAntiguoOperador && row.operadorMonitoreo != 'OTRO'" style="
                        display: inline-block;
                        margin-top: 0.25rem;
                        font-size: 0.875rem;
                        font-family: Arial, sans-serif;
                        color: #495057;
                      ">
                  {{ row.operadorMonitoreo }}
                </span>
              </ng-container>


              <ng-container *ngSwitchDefault>
                <ng-container [ngSwitch]="col.type">
                  <ng-container *ngSwitchCase="'number'">
                    <div class="table-cell-content">
                      {{ sanitizeKm(row[col.field]) }}
                    </div>
                  </ng-container>

                  <ng-container *ngSwitchDefault>
                    <div class="table-cell-content">
                      {{ row[col.field] || "-" }}
                    </div>
                  </ng-container>
                </ng-container>
              </ng-container>



            </ng-container>
          </ng-container>

        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="columns.length + 1" class="text-center" style="padding: 2rem;">
          No hay registros disponibles.
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="paginatorright" *ngIf="withButtonDriversList">
      <span class="custom-message success-message" *ngIf="customMessageUpdateListaDriver">
        {{customMessageUpdateListaDriver}}
      </span>
      <span class="custom-message error-message" *ngIf="customMessageErrorListaDriver">
        {{customMessageErrorListaDriver}}
      </span>
    </ng-template>

  </p-table>
  <div *ngIf="loading" class="loading-overlay">
    <div class="loading-content">
      <i class="pi pi-spin pi-spinner"></i>
      <span>Obteniendo lista de conductores...</span>
    </div>
  </div>
</div>




<p-dialog *ngIf="withShowAll" [(visible)]="showAll" [modal]="true"
  [style]="{width: '55vw', 'max-height': '90vh', 'overflow': 'auto'}" [contentStyle]="{'padding-bottom': '2rem'}"
  [header]="dialogTitle" [closable]="true" (onHide)="onDialogClosed()">
  <ng-container *ngIf="rowReportGeneralAll">
    <p-table #dtDialog [value]="rowReportGeneralAll.records" [paginator]="false" [rows]="rowReportGeneralAll.length"
      [virtualScroll]="false" [scrollable]="true" [scrollHeight]="'60vh'" [globalFilterFields]="globalFilterFields"
      [styleClass]="''">
      <!-- Funcionalidades -->
      <ng-template pTemplate="caption">
        <div class="d-flex space-between w-100">
          <div class="d-flex flex-column gap-2 mb-2">
            <!-- Barra superior con búsqueda -->
            <div class="p-d-flex p-jc-between p-ai-center p-flex-wrap">
              <div class="p-input-icon-left" style="width: 250px;">
                <i class="pi pi-search"></i>
                <input pInputText type="text" (input)="dtDialog.filterGlobal($event.target.value, 'contains')"
                  placeholder="Buscar..." class="p-inputtext-sm w-full" />
              </div>
            </div>
          </div>

          <!-- Botones de exportación al extremo derecho -->
          <div class="d-flex justify-content-center align-items-center gap-3"
            style="margin-left:auto; font-size:0.9rem;">
            <!-- Resumen de registros -->
            <div class="text-secondary d-flex align-items-center gap-2">
              <span>Total: <strong>{{ dtDialog.totalRecords }}</strong> registros</span>
            </div>
          </div>

        </div>
      </ng-template>


      <!-- Cabezera -->
      <ng-template pTemplate="header">
        <tr>
          <th *ngFor="let col of columns" [style.width]="col.width" pSortableColumn="{{ col.field }}"
            class="header-cell">

            <ng-container *ngIf="col">
              <ng-container [ngSwitch]="col.field">
                <ng-container *ngSwitchCase="'excesoVelocidad'">
                  <div style="display: flex; flex-direction: column; align-items: start;">
                    <div style="width: 100%; text-align: center"><strong>{{ col.header }}</strong></div>
                    <div
                      style="display: flex; gap: 16px; margin-top: 4px; justify-content: space-between; width: 100%; align-items: center;">
                      <ng-container *ngFor="let sub of col.subColumns">
                        <span [ngClass]="{
                          'text-green': sub.field === 'leve',
                          'text-yellow': sub.field === 'grave',
                          'text-red': sub.field === 'muyGrave'
                        }" style="font-weight: normal; width: 100%; text-align: center;">{{ sub.header }}</span>
                      </ng-container>
                    </div>
                  </div>
                </ng-container>

                <ng-container *ngSwitchCase="'datosEvento'">
                  <div style="display: flex; flex-direction: column; align-items: start;">
                    <div style="width: 100%; text-align: center"><strong>{{ col.header }}</strong></div>
                    <div
                      style="display: flex; gap: 16px; margin-top: 4px; justify-content: space-between; width: 100%; align-items: center;">
                      <ng-container *ngFor="let sub of col.subColumns">
                        <span style="font-weight: normal; width: 100%; text-align: center;">{{ sub.header }}</span>
                      </ng-container>
                    </div>
                  </div>
                </ng-container>

                <ng-container *ngSwitchCase="'datosChecklist'">
                  <div style="display: flex; flex-direction: column; align-items: start;">
                    <div style="width: 100%; text-align: center"><strong>{{ col.header }}</strong></div>
                    <div
                      style="display: flex; gap: 16px; margin-top: 4px; justify-content: space-between; width: 100%; align-items: center;">
                      <ng-container *ngFor="let sub of col.subColumns">
                        <span style="font-weight: normal; width: 100%; text-align: center;">{{ sub.header }}</span>
                      </ng-container>
                    </div>
                  </div>
                </ng-container>

                <ng-container *ngSwitchDefault>
                  <span>
                    {{ col.header }}
                  </span>
                  <p-sortIcon [field]="col.field"></p-sortIcon>
                </ng-container>
              </ng-container>
            </ng-container>
          </th>
        </tr>
      </ng-template>

      <!-- Registros de la tabla -->
      <ng-template pTemplate="body" let-row let-rowIndex="rowIndex">
        <tr [ngClass]="{
            'fila-par': (dtDialog.first + rowIndex) % 2 === 0,
            'fila-impar': (dtDialog.first + rowIndex) % 2 !== 0
          }" [style.background-color]="row.isResumen == true ? '#E5E3D9' : ''">
          <td *ngFor="let col of columns" [style.width]="col.width" class="body-cell">

            <ng-container *ngIf="col">
              <ng-container [ngSwitch]="col.field">
                <ng-container *ngSwitchCase="'ubicacion'">
                  <a [href]="row.ubicacionLink" target="_blank">{{row.ubicacion}}</a>
                </ng-container>

                <ng-container *ngSwitchCase="'observacion'">
                  <input pInputText type="text" [(ngModel)]="row.observacion" (change)="onChangeObservacion(row)">
                </ng-container>


                <ng-container *ngSwitchCase="'excesoVelocidad'">

                  <div
                    style="display: flex; gap: 16px; margin-top: 4px; justify-content: space-between; width: 100%; align-items: center;">
                    <ng-container *ngFor="let sub of col.subColumns">
                      <span style="font-weight: normal; width: 100%; text-align: center;" [ngClass]="{
                            'text-green': sub.field === 'leve',
                            'text-yellow': sub.field === 'grave',
                            'text-red': sub.field === 'muyGrave'
                          }">{{ row[sub.field] || "-" }}</span>
                    </ng-container>
                  </div>
                </ng-container>

                <ng-container *ngSwitchCase="'criterioEvaluacion'">
                  <p-dropdown [showClear]="true"
                    [panelStyle]="{ 'background-color': '#ffffff', 'font-size': '0.875rem', 'box-shadow': 'none', 'border-radius': '0' }"
                    [appendTo]="'body'" [options]="getCriterioEvaluationOptionsForRow(row.slug)" [group]="true"
                    [(ngModel)]="row.criterioId" filterBy="label" placeholder="Criterios ..."
                    (onChange)="onChangeCriterioEvaluacion($event, row)" emptyMessage="No se encontraron registros"
                    emptyFilterMessage="No se han encontrado Criterios" filterMatchMode="contains"
                    [style]="{ width: '100%', 'max-width': '15rem', padding: '0.5rem 0.5rem', 'font-family': 'Arial, sans-serif' }">

                    <!-- Estilizando el grupo -->
                    <ng-template let-group pTemplate="group">
                      <div class="p-d-flex p-ai-center d-flex justify-content-center">
                        <span>{{ group.label }}</span>
                      </div>
                    </ng-template>

                    <!-- Estilizando el ícono de dropdown -->
                    <ng-template let-option pTemplate="selectedItem">
                      <div class="p-d-flex p-ai-center">
                        <span>{{ option.label || option.value }}</span>
                      </div>
                    </ng-template>

                  </p-dropdown>


                  <span *ngIf="row.criterioId || row.fechaEvaluacion">
                    {{row.criterioEvaluacion || 'Sin criterio'}}
                  </span>

                  <br *ngIf="row.senalesPosibleFatiga">
                  <input *ngIf="row.senalesPosibleFatiga" pInputText type="text" [(ngModel)]="row.identificacionVideo"
                    (change)="onChangeObservacion(row)" placeholder="Identificar video">

                  <div *ngIf="row.isConfirmed" class="form_stars">
                    <p class="clasificacion">
                      <ng-container *ngFor="let star of [5,4,3,2,1]; let i = index">
                        <input id="radio{{star}}_{{rowIndex}}" type="radio" [(ngModel)]="row.valoracionEvento"
                          (change)="onChangeObservacion(row)" [value]="star" />
                        <label for="radio{{star}}_{{rowIndex}}">★</label>
                      </ng-container>
                    </p>
                  </div>
                </ng-container>


                <ng-container *ngSwitchCase="'enlaceArchivo'">
                  <a href="{{row.enlaceImagen}}" target="_blank">Imagen</a>/
                  <a href="{{row.enlaceVideo}}" target="_blank">Video</a>
                </ng-container>

                <ng-container *ngSwitchCase="'zonaColor'">
                  <div style="display: flex; align-items: center; gap: 8px;">
                    <!-- Muestra de color -->
                    <div [style.backgroundColor]="row[col.field]"
                      style="width: 16px; height: 16px; border-radius: 4px; border: 1px solid #ccc;"></div>
                    <!-- Texto del color -->
                    <span>{{ row[col.field] }}</span>
                  </div>
                </ng-container>

                <ng-container *ngSwitchCase="'zonaColor'">
                  <div style="display: flex; align-items: center; gap: 8px;">
                    <!-- Muestra de color -->
                    <div [style.backgroundColor]="row[col.field]"
                      style="width: 16px; height: 16px; border-radius: 4px; border: 1px solid #ccc;"></div>
                    <!-- Texto del color -->
                    <span>{{ row[col.field] }}</span>
                  </div>
                </ng-container>

                <ng-container *ngSwitchCase="'enlaceVideo'">
                  <a [href]="row.linkVideo" target="_blank">Video</a>
                </ng-container>

                <ng-container *ngSwitchCase="'enlaceImagen'">
                  <a [href]="row.linkImage" target="_blank">Imagen</a>
                </ng-container>

                <ng-container *ngSwitchCase="'conductor'">
                  <span>
                    {{ row.conductor }}
                  </span>
                </ng-container>

                <ng-container *ngSwitchCase="'datosEvento'">
                  <div
                    style="display: flex; gap: 16px; margin-top: 4px; justify-content: space-between; width: 100%; align-items: center;">
                    <ng-container *ngFor="let sub of col.subColumns">
                      <span style="font-weight: normal; width: 100%; text-align: center;" [ngClass]="{
                            'text-green': sub.field === 'leve',
                            'text-yellow': sub.field === 'grave',
                            'text-red': sub.field === 'muyGrave'
                          }">{{ row[sub.field] || "-" }}</span>
                    </ng-container>
                  </div>
                </ng-container>

                <ng-container *ngSwitchCase="'previsualizacion'">
                  <ng-container *ngIf="imageCache[row.fecha] as img; else pending">
                    <!-- Estado: cargando -->
                    <div *ngIf="img.isLoading" class="image-placeholder">
                      <span class="spinner-border spinner-border-sm mb-2"></span>
                      <span>Cargando imagen...</span>
                    </div>

                    <!-- Estado: éxito -->
                    <img *ngIf="!img.isLoading && !img.hasError" [src]="img.safeUrl" alt="Imagen evento" width="120"
                      height="90" class="rounded shadow" />

                    <!-- Estado: error -->
                    <div *ngIf="img.hasError">
                      <i class="bi bi-exclamation-triangle mb-2"></i>
                      No se pudo cargar la imagen
                    </div>

                  </ng-container>

                  <!-- Estado inicial: aún no procesado -->
                  <ng-template #pending>
                    <div class="image-placeholder">
                      <span class="text-muted">Imagen en proceso</span>
                    </div>
                  </ng-template>
                </ng-container>

                <ng-container *ngSwitchCase="'datosChecklist'">
                  <div style="display: flex; flex-direction: column; gap: 4px; width: 100%; margin-top: 4px;">
                    <ng-container *ngFor="let checklist of row[col.field]">
                      <div class="checklist-row">
                        <li [ngClass]="{'highlight-driver': row.conductor === checklist.name_driver}">
                          {{ checklist.date_checklist || "-"}}
                        </li>
                        <li [ngClass]="{'highlight-driver': row.conductor === checklist.name_driver}">
                          {{ checklist.name_driver || "-"}}
                        </li>
                        <li [ngClass]="{'highlight-driver': row.conductor === checklist.name_driver}">
                          {{ checklist.string_timing || "-" }}
                        </li>
                        <li [ngClass]="{'highlight-driver': row.conductor === checklist.name_driver}">
                          {{ checklist.cod_driver || "-"}}
                        </li>
                      </div>
                    </ng-container>
                  </div>
                </ng-container>

                <ng-container *ngSwitchCase="'operadorMonitoreo'">

                  <select [(ngModel)]="row.operadorMonitoreo" style="width:100%;"
                    (change)="onChangeOperadorMonitoreo(row)">
                    <option value="">OPCIONES</option>
                    <option *ngFor="let operator of report.operators" [value]="operator.value">{{ operator.label }}
                    </option>
                    <option value="OTRO">OTRO</option>
                  </select>


                  <input *ngIf="row.operadorMonitoreo == 'OTRO'" pInputText type="text"
                    [(ngModel)]="row.otroOperadorMonitoreo" (change)="onChangeOperadorMonitoreo(row)">

                  <span *ngIf="row.esAntiguoOperador">
                    {{row.operadorMonitoreo}}
                  </span>
                </ng-container>


                <ng-container *ngSwitchDefault>
                  <div class="table-cell-content">
                    {{ sanitizeKm(row[col.field]) }}
                  </div>
                </ng-container>


              </ng-container>
            </ng-container>

          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="columns.length + 1" class="text-center" style="padding: 2rem;">
            No hay registros disponibles.
          </td>
        </tr>
      </ng-template>
    </p-table>


    <div *ngIf="rowReportGeneralAll.summary">
      <app-report-summary [summary]="rowReportGeneralAll.summary">
      </app-report-summary>
    </div>

    <div class="export-container" *ngIf="report">
      <ng-container *ngIf="report.permission && report.permission.export">
        <ng-container>
          <ng-container *appHasPermission="report.permission.export.excel">
            <button class="btn btn-gl btn-success btn-dark-hover" (click)="exportReport('excel')">
              EXPORTAR EXCEL
            </button>
          </ng-container>
        </ng-container>

        <ng-container>
          <ng-container *appHasPermission="report.permission.export.pdf">
            <button class="btn btn-gl btn-gl-red btn-dark-hover" (click)="exportReport('pdf')">
              EXPORTAR PDF
            </button>
          </ng-container>
        </ng-container>

        <ng-container>
          <ng-container *appHasPermission="report.permission.export.html">
            <button class="btn btn-gl btn-gl-red btn-dark-hover" style="background-color: #fd7e14;"
              (click)="exportReport('html')">
              EXPORTAR HTML
            </button>
          </ng-container>
        </ng-container>

      </ng-container>
    </div>
  </ng-container>
</p-dialog>
